import { INFO_CONTENT_TYPE } from "./constants"

//======= WARNING: All keys are REQUIRED for chatbot text in any language ========
//----- means keys should be common in all language text.
//----- copy englishText for any new language text and update the value only.

export const english = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "End chat",
  poweredBy: "Powered by",
  typeYourQuery: "Type your query...",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Do you want to close this session?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirm",
  cancel: "Cancel",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
  otp_content: {
    input_account_text:
      "To continue further as a member please authenticate yourself using your registered account.",
    title: "Please enter the OTP we've sent you on your registered account",
    redirect_message: "Redirecting you to the chat...",
    success_message: "You’ve been verified successfully🎉!",
    buttonsText: {
      go_back: "Go Back",
      get_otp: "Get OTP",
      resend_otp: "Resend OTP",
      validate: "Validate",
    },
    enter_otp: "Enter OTP",
    resend_prompt: "Didn't receive OTP?",
  },
}

export const usa = {
  brandName: 'EF Education First',
  online: 'online',
  offline: 'offline',
  connecting: 'connecting...',
  endChat: 'End chat',
  poweredBy: 'Powered by',
  typeYourQuery: 'Type your query...',
  listening: 'Listening...',
  menu: 'Menu',
  clearChat: 'Clear chat',
  clearChatmessage: 'Are you sure you want to clear the chat?',
  privacyPolicy: 'Privacy Policy',
  feedback: 'Feedback',
  termsAndConditions: 'Terms & Conditions',
  connectionLost: 'connection lost',
  feedbackGreeting: 'How happy are you with our support?',
  feedbackLowRatedStatus: 'Please tell us what went wrong.',
  feedbackHighRatedStatus:
    'Please suggest how can we make your next visit awesome.',
  feedbackSuccess: 'Thank you for giving us feedback',
  feedbackFailed: 'Some error occured please try again later',
  downtimeStatusPrefix: 'we will try to fix it before',
  downtimeStatusPostfix: '. sorry for the inconvenience.',
  sessionCloseConfirmation: 'Do you want to close this session?',
  resolveChatInfo: 'Agent has ended the conversation.',
  writeYourComment: 'Write your comment…',
  fileSelected: 'No preview found',
  confirm: 'Confirm',
  cancel: 'Cancel',
  ok: 'Ok',
  skip: 'Skip',
  Yes: 'Yes',
  No: 'No',
  submit: 'Submit',
  success: 'Success',
  failed: 'Failed',
  close: 'Close',
  send: 'Send',
  show_more: 'Show more',
  show_less: 'Show less',
  overflow_showmore: 'Show more',
  security_prompt:
    'This is a confidential URL. To access this URL please enter your security code.',
  today: 'Today',
  yesterday: 'Yesterday',
  typewriter_data: ['Click here to type your query...'],
  download_chatlog_description:
    'you can only download/email last 24 hours of chatlogs',
  download_chatlog: 'Download chatlogs',
  email_chatlog: 'Email chatlogs',
  download: 'Download',
  choose_chatlog_type: 'Choose any format to continue',
  invalid_email_text: 'Please enter a valid email id',
  unknown_type_info_content:
    'is not define in info content. Click here to close this.',
  api_error: 'Something went wrong',
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: '', // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: '', // Enter Html string here
  },
  file_upload: 'File Upload',
  no_of_pages: 'pages',
  input_lock_text: 'please select any option to proceed',
  reply: 'Reply',
  menu_feedback_options: ['Terrible', 'Bad', 'Average', 'Good', 'I love it'],
  edited: 'Edited',
  disclaimer:
    'Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.',
}

export const canada = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "End chat",
  poweredBy: "Powered by",
  typeYourQuery: "Write here",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Do you want to close this session?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirm",
  cancel: "Cancel",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
}

export const italian = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Cancella chat",
  poweredBy: "Powered by",
  typeYourQuery: "Scrivi qui…",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Vuoi cancellare questa conversazione?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Conferma",
  cancel: "Annulla",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const japenese = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "会話を終了する",
  poweredBy: "Powered by",
  typeYourQuery: "こちらにご記入ください。",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "この会話を終了しますか？",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "終了する",
  cancel: "キャンセル",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const swedish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Avsluta chat",
  poweredBy: "Powered by",
  typeYourQuery: "Skriv ditt meddelande här",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Vill du avsluta denna chat?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Godkänn",
  cancel: "Avsluta",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const argentina_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribí acá",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Querés cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const austria_german = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Chat beenden",
  poweredBy: "Powered by",
  typeYourQuery: "Hier schreiben",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Möchtest du diesen Chat beenden?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Bestätigen",
  cancel: "Abbrechen",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const belgium_french = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Terminer la discussion",
  poweredBy: "Powered by",
  typeYourQuery: "Écrivez ici",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Voulez-vous terminer cette discussion ?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirmer",
  cancel: "Annuler",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const belgium_dutch = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Beëindig chat",
  poweredBy: "Powered by",
  typeYourQuery: "Type hier",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Wil je de chat beëindigen?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Bevestigen",
  cancel: "Annuleren",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const switzerland_french = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Terminer la discussion",
  poweredBy: "Powered by",
  typeYourQuery: "Écrivez ici",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Voulez-vous terminer cette discussion ?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirmer",
  cancel: "Annuler",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const switzerland_german = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Chat beenden",
  poweredBy: "Powered by",
  typeYourQuery: "Hier schreiben",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Möchtest du diesen Chat beenden?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Bestätigen",
  cancel: "Abbrechen",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const switzerland_italian = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "End chat",
  poweredBy: "Powered by",
  typeYourQuery: "Type your query...",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Do you want to close this session?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirm",
  cancel: "Cancel",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const chile_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const colombia_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const german = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Chat beenden",
  poweredBy: "Powered by",
  typeYourQuery: "Hier schreiben",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Möchtest du diesen Chat beenden?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Bestätigen",
  cancel: "Abbrechen",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const ecuador_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const finnish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Lopeta keskustele",
  poweredBy: "Powered by",
  typeYourQuery: "Kirjoita tähän",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Haluatko sulkea tämän keskustelun?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Vahvista",
  cancel: "Peruuta",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const french = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Terminer la discussion",
  poweredBy: "Powered by",
  typeYourQuery: "Écrire ici",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Voulez-vous fermer cette session ?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmer",
  cancel: "Annuler",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const kazakhstan_russian = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Закончить чат",
  poweredBy: "Powered by",
  typeYourQuery: "Написать здесь",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Вы хотите завершить?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Подтвердить",
  cancel: "Закончить",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const mexico_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const dutch = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Beëindig chat",
  poweredBy: "Powered by",
  typeYourQuery: "Type hier",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Wil je de chat beëindigen?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Bevestigen",
  cancel: "Annuleren",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const panama_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const peru_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Finalizar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribir aquí",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Quiere cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const russian = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Закончить чат",
  poweredBy: "Powered by",
  typeYourQuery: "Написать здесь",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Вы хотите завершить?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Подтвердить",
  cancel: "Закончить",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const saudiarabia_arabic = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "إنهاء المحادثة",
  poweredBy: "Powered by",
  typeYourQuery: "اكتب هنا",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "هل ترغب في إنهاء هذه الجلسة؟",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "تأكيد",
  cancel: "إلغاء",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const turkish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Sohbeti Sonlandır",
  poweredBy: "Powered by",
  typeYourQuery: "Buraya yaz",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Bu oturumu kapatmak istiyor musun?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Onayla",
  cancel: "İptal",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const uruguay_spanish = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Terminar chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escribí acá",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "¿Querés cerrar esta sesión",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const brazil = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Encerrar Chat",
  poweredBy: "Powered by",
  typeYourQuery: "Escreva aqui",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Deseja encerrar essa sessão?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const south_korea = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "채팅 종료",
  poweredBy: "Powered by",
  typeYourQuery: "궁금한 점을 여기에 입력하세요.",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "이 세션을 종료하시겠어요?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "확인",
  cancel: "취소",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const poland = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Zakończ czat",
  poweredBy: "Powered by",
  typeYourQuery: "Napisz tutaj",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Czy chcesz zamknąć tę sesję?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Potwierdź",
  cancel: "Anuluj",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const portugal = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Terminar conversa",
  poweredBy: "Powered by",
  typeYourQuery: "Escreva aqui",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Quer terminar esta sessão?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirmar",
  cancel: "Cancelar",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const czech_republic = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Ukončit Chatt",
  poweredBy: "Powered by",
  typeYourQuery: "Type your query...",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Chcete ukončiti tuto relaci?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected:"No preview found",
  confirm: "Potvrdit",
  cancel: "Zrušit",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Zadejte prosím platnou e-mailovou adresu",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}
export const slovakia = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Ukončiť chat",
  poweredBy: "Powered by",
  typeYourQuery: "Napíšte sem",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Chcete túto konverzáciu ukončiť?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Potvrdiť",
  cancel: "Zrušiť",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Prosím, zadaj platnú email adresu",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
}

export const romania = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Închide conversația",
  poweredBy: "Powered by",
  typeYourQuery: "Scrie aici",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Vrei să închizi această sesiune?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Confirmă",
  cancel: "Anulează",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
}

export const hong_kong = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "結束聊天",
  poweredBy: "Powered by",
  typeYourQuery: "✍️ 請在這裡輸入",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "你要關閉這個對話嗎？",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "確認",
  cancel: "取消",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
  otp_content: {
    input_account_text:
      "To continue further as a member please authenticate yourself using your registered account.",
    title: "Please enter the OTP we've sent you on your registered account",
    redirect_message: "Redirecting you to the chat...",
    success_message: "You’ve been verified successfully🎉!",
    buttonsText: {
      go_back: "Go Back",
      get_otp: "Get OTP",
      resend_otp: "Resend OTP",
      validate: "Validate",
    },
    enter_otp: "Enter OTP",
    resend_prompt: "Didn't receive OTP?",
  },
}

export const taiwan = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "結束對話",
  poweredBy: "Powered by",
  typeYourQuery: "這裡輸入文字",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "你確定要結束這次對話嗎？",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "確定",
  cancel: "取消",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
  otp_content: {
    input_account_text:
      "To continue further as a member please authenticate yourself using your registered account.",
    title: "Please enter the OTP we've sent you on your registered account",
    redirect_message: "Redirecting you to the chat...",
    success_message: "You’ve been verified successfully🎉!",
    buttonsText: {
      go_back: "Go Back",
      get_otp: "Get OTP",
      resend_otp: "Resend OTP",
      validate: "Validate",
    },
    enter_otp: "Enter OTP",
    resend_prompt: "Didn't receive OTP?",
  },
}

export const denmark = {
  brandName: "EF Education First",
  online: "online",
  offline: "offline",
  connecting: "connecting...",
  endChat: "Afslut chat",
  poweredBy: "Powered by",
  typeYourQuery: "Skriv her",
  listening: "Listening...",
  menu: "Menu",
  clearChat: "Clear chat",
  clearChatmessage: "Are you sure you want to clear the chat?",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  termsAndConditions: "Terms & Conditions",
  connectionLost: "connection lost",
  feedbackGreeting: "How happy are you with our support?",
  feedbackLowRatedStatus: "Please tell us what went wrong.",
  feedbackHighRatedStatus:
    "Please suggest how can we make your next visit awesome.",
  feedbackSuccess: "Thank you for giving us feedback",
  feedbackFailed: "Some error occured please try again later",
  downtimeStatusPrefix: "we will try to fix it before",
  downtimeStatusPostfix: ". sorry for the inconvenience.",
  sessionCloseConfirmation: "Vil du lukke denne chat?",
  resolveChatInfo: "Agent has ended the conversation.",
  writeYourComment: "Write your comment…",
  fileSelected: "No preview found",
  confirm: "Bekræft",
  cancel: "Annuller",
  ok: "Ok",
  skip: "Skip",
  Yes: "Yes",
  No: "No",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  close: "Close",
  send: "Send",
  show_more: "Show more",
  show_less: "Show less",
  overflow_showmore: "Show more",
  security_prompt:
    "This is a confidential URL. To access this URL please enter your security code.",
  today: "Today",
  yesterday: "Yesterday",
  typewriter_data: ["Click here to type your query..."],
  download_chatlog_description:
    "you can only download/email last 24 hours of chatlogs",
  download_chatlog: "Download chatlogs",
  email_chatlog: "Email chatlogs",
  download: "Download",
  choose_chatlog_type: "Choose any format to continue",
  invalid_email_text: "Please enter a valid email id",
  unknown_type_info_content:
    "is not define in info content. Click here to close this.",
  api_error: "Something went wrong",
  info_content: {
    [INFO_CONTENT_TYPE.PRIVACY_POLICY]: "", // Enter Html string here
    [INFO_CONTENT_TYPE.TERMS_AND_CONDITIONS]: "", // Enter Html string here
  },
  file_upload: "File Upload",
  no_of_pages: "pages",
  input_lock_text: "please select any option to proceed",
  reply: "Reply",
  menu_feedback_options: ["Terrible", "Bad", "Average", "Good", "I love it"],
  edited: "Edited",
  disclaimer:
    "Disclaimer: This chatbot provides general information and may not always be correct. For concerns or doubts, refer to company policies or contact support.",
  otp_content: {
    input_account_text:
      "To continue further as a member please authenticate yourself using your registered account.",
    title: "Please enter the OTP we've sent you on your registered account",
    redirect_message: "Redirecting you to the chat...",
    success_message: "You’ve been verified successfully🎉!",
    buttonsText: {
      go_back: "Go Back",
      get_otp: "Get OTP",
      resend_otp: "Resend OTP",
      validate: "Validate",
    },
    enter_otp: "Enter OTP",
    resend_prompt: "Didn't receive OTP?",
  },
}

